import type { LayoutEdge, LayoutNode } from './graphLayout';

/** The id the backend gives a real Brain document; anything else labelled "Document" was extracted from the text. */
const REAL_DOCUMENT_PREFIX = 'doc:';

/**
 * Indexing asks a language model for the entities in a text, and "Document" is
 * one of the types it may answer with — so a document that mentions another
 * document (or its own name) yields extra nodes labelled "Document" next to the
 * real one. Drawn in the middle with the real documents they read as duplicates.
 * Only nodes the backend itself created (`doc:<path>`) are documents; the rest
 * are references TO documents and go on the ring with the other entities.
 */
export function normalizeGraph<N extends LayoutNode, E extends LayoutEdge>(
  data: { nodes: N[]; edges: E[] },
): { nodes: N[]; edges: E[] } {
  return {
    nodes: data.nodes.map((node) =>
      node.label === 'Document' && !node.id.startsWith(REAL_DOCUMENT_PREFIX)
        ? { ...node, label: 'Reference' }
        : node,
    ),
    edges: data.edges,
  };
}
